module.exports = __webpack_public_path__ + "img/defaultImage.4b79e6e1.png";